var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back_to_top",on:{"click":function($event){_vm.$document.documentElement.scrollTop = 0}}},[_vm._v(" Back to top ")])}
var staticRenderFns = []

export { render, staticRenderFns }